// extracted by mini-css-extract-plugin
export var card = "DCard-module--card---NXy1";
export var left = "DCard-module--left--obFPi";
export var images = "DCard-module--images--r4dG2";
export var bgImg = "DCard-module--bgImg--XFtdB";
export var profileImg = "DCard-module--profileImg--+lnBR";
export var right = "DCard-module--right--67vnA";